<template>
  <div class="list" name="add">
    <el-col>
      <el-card style="margin-bottom:20px" shadow="never">
        <el-form
          label-position="left"
          style="margin-top: 20px;"
          label-width="130px"
          :model="addForm"
          :rules="rule_data"
          ref="addForm">
          <el-form-item label="登录账号" prop="cashierAccount">
            <el-input v-model="addForm.cashierAccount" clear style="width:30%;" placeholder="8-20位数字或字母"></el-input>
            <auth-button
              opt="check_agent"
              icon="el-icon-search"
              class="check"
              @click.native="checkSubAg"
              :loading="checkLoading"
              label="检测"></auth-button>
          </el-form-item>
          <el-form-item label="登录密码" prop="password">
            <el-input v-model="addForm.password" type="password" clear style="width:30%;" placeholder="8-20位大写/小写字母/数字/符号中的至少三种组合"></el-input>
          </el-form-item>
          <el-form-item label="收银员姓名" prop="cashierName">
            <el-input v-model="addForm.cashierName" clear style="width:30%;"></el-input>
          </el-form-item>
          <el-form-item label="收银员手机" prop="mobile">
            <el-input v-model="addForm.mobile" clear style="width:30%;"></el-input>
          </el-form-item>
          <el-form-item label="员工类型" prop="userType">
            <el-select v-model="addForm.userType" placeholder="员工类型" style="width:140px;" clearable>
              <el-option label="店员" value="0"></el-option>
              <el-option label="店长" value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <auth-button opt="submit" icon="el-icon-circle-plus-outline" @click.native="addSubmit('addForm')" :loading="addLoading" label="提交"></auth-button>
      </el-card>
    </el-col>
  </div>
</template>

<script>
import qs from 'qs'
import { validateCashierAc, addCashierAc } from '@/api/cashier.js'
import md5 from 'js-md5'
import { validStrictPsd, strictPsdError } from '@/utils/validate.js'
export default {
  data () {
    return {
      rule_data: {
        cashierAccount: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('账号不能空'))
            } else {
              if (/^[a-zA-Z0-9]{8,20}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入正确的账号格式'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        password: [{
          validator: (rule, value, callback) => {
            if (validStrictPsd(value)) {
              callback()
            } else {
              return callback(new Error(strictPsdError))
            }
          },
          required: true,
          trigger: 'blur'
        }],
        cashierName: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入真实姓名'))
            } else {
              if (/^[\u4E00-\u9FA5A-Za-z0-9]{2,20}$/.test(value)) {
                callback()
              } else {
                callback(new Error('长度在2到20之间,且只能包含数字、字母、汉字.'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        mobile: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入手机号码'))
            } else {
              if (!(/^\d{11,11}$/.test(value))) {
                callback(new Error('请输入11位手机号码'))
              } else {
                callback()
              }
            }
          },
          required: true,
          trigger: 'blur'
        }]
      },
      // 新增界面数据
      addForm: {
        cashierAccount: '',
        password: '',
        cashierName: '',
        mobile: '',
        userType: ''
      },
      checkLoading: false,
      addLoading: false
    }
  },
  methods: {
    // 检测账号可用性
    checkSubAg () {
      var Cashier = this.addForm.cashierAccount
      Cashier = { cashierAccount: Cashier }
      Cashier = qs.stringify(Cashier)
      this.checkLoading = true
      validateCashierAc(Cashier).then(data => {
        this.checkLoading = false
        if (parseInt(data.error_code) === 0) {
          this.$message({
            message: data.error_msg,
            type: 'success'
          })
        } else {
          this.$message({
            message: data.error_msg,
            type: 'warning'
          })
        }
      })
    },
    // 新增收银员
    addSubmit (addForm) {
      var that = this
      var pw = this.addForm.password
      // this.$refs[addForm].validate((valid) => {
      // if (valid) {
      this.$confirm('确认提交吗？', '提示', {}).then(() => {
        this.addLoading = true
        let para = Object.assign({}, this.addForm)
        para = JSON.parse(JSON.stringify(para))
        if (pw) { para.password = md5(pw) }
        para = qs.stringify(para)
        addCashierAc(para).then(data => {
          this.addLoading = false
          if (parseInt(data.error_code) === 0) {
            this.$message({
              message: data.error_msg,
              type: 'success'
            })
            that.$refs.addForm.resetFields()
          } else {
            this.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
            that.$refs.addForm.resetFields()
          }
        })
      })
      // }
      // });
    }
  }
  // ,
  // mounted() {
  //   this.addSubmit();
  // },
  // watch: {
  //   $route(to, from){
  //     this.addSubmit();
  //   }
  // }
}

</script>
<style rel="stylesheet/scss" lang="scss">
    .demo-form-inline {
        display: inline-block;
        float: right;
    }

    .btm-action {
        margin-top: 20px;
        text-align: center;
    }

    .pagination {
        display: inline-block;
    }
    .list{
        padding-left: 16px;
    }
    .tab-tag{
      height:0;
      padding: 0;
      line-height: 0;
      background: transparent;
    }
    .dsn{
        display: none;
    }
    .check{
      margin-left: 2%;
    }
    // .btn{
    //   margin-left: 40%;
    // }
</style>
